var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-header",
    [
      _c(
        "q-toolbar",
        [
          _c("q-btn", {
            attrs: { flat: "", round: "", small: "", icon: "menu" },
            on: {
              click: function($event) {
                _vm.showLeft = !_vm.showLeft
              }
            }
          }),
          _c("q-toolbar-title", [
            _c(
              "strong",
              {
                staticClass: "toolbar-title clicavel",
                on: {
                  click: function($event) {
                    _vm.home()
                  }
                }
              },
              [_vm._v("Protocolo")]
            )
          ]),
          _vm.setQtdeNotificacao() !== 0
            ? _c(
                "q-chip",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarNotificacoes,
                      expression: "mostrarNotificacoes"
                    }
                  ],
                  attrs: { dense: "", color: "red-5", "text-color": "white" }
                },
                [_vm._v(_vm._s(_vm.setQtdeNotificacao()))]
              )
            : _vm._e(),
          _c(
            "q-btn-dropdown",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostrarNotificacoes,
                  expression: "mostrarNotificacoes"
                }
              ],
              staticStyle: { "-webkit-box-shadow": "0 0 0 0" },
              attrs: { color: "primary", icon: "mail", dense: "", small: "" }
            },
            [
              _c(
                "q-list",
                { attrs: { link: "", separator: "" } },
                [
                  _vm._l(_vm.arrayNotificacao, function(n) {
                    return _c(
                      "q-item",
                      {
                        key: n.a,
                        nativeOn: {
                          click: function($event) {
                            _vm.responderSolicitacao(
                              n.protocoloSolicitacao.id,
                              n.codNotificacaoSolicitacao
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "q-item-main",
                          { staticStyle: { width: "100%" } },
                          [
                            n.indAtiva === "N"
                              ? _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.setDataNotificacao(n.datNotificacao)
                                    ) +
                                      " Solicitação Nº: " +
                                      _vm._s(
                                        n.protocoloSolicitacao.numSolicitacao
                                      )
                                  )
                                ])
                              : _c("q-item-tile", { attrs: { label: "" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.setDataNotificacao(n.datNotificacao)
                                      ) +
                                        " Solicitação Nº: " +
                                        _vm._s(
                                          n.protocoloSolicitacao.numSolicitacao
                                        )
                                    )
                                  ])
                                ]),
                            n.indAtiva === "N"
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      n.protocoloSolicitacao.requerente
                                        .nomeDocumento
                                    )
                                  )
                                ])
                              : _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        n.protocoloSolicitacao.requerente
                                          .nomeDocumento
                                      )
                                    )
                                  ])
                                ]),
                            n.indAtiva === "N"
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(_vm._s(n.desMensagem))
                                ])
                              : _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _c("strong", [_vm._v(_vm._s(n.desMensagem))])
                                ])
                          ],
                          1
                        ),
                        _c("q-item-side", {
                          attrs: {
                            right: "",
                            dense: "",
                            icon: "fas fa-external-link-alt",
                            color: "blue"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm.arrayNotificacao.length === 0
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-side", {
                            attrs: {
                              right: "",
                              dense: "",
                              icon: "far fa-smile-beam",
                              color: "blue-6"
                            }
                          }),
                          _c(
                            "q-item-main",
                            { staticStyle: { width: "100%" } },
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(" Nenhuma Notificação Web ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "q-btn-dropdown",
            {
              staticStyle: { "-webkit-box-shadow": "0 0 0 0" },
              attrs: {
                icon: "fas fa-user-alt",
                small: "",
                dense: "",
                color: "primary"
              }
            },
            [
              _c(
                "q-list",
                { staticStyle: { "min-width": "100px" }, attrs: { link: "" } },
                [
                  _c(
                    "q-item",
                    {
                      attrs: { clickable: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.abrirCadunico()
                        }
                      }
                    },
                    [
                      _c("q-icon", {
                        staticClass: "icone-menu-suspenso fas fa-home"
                      }),
                      _vm._v("\n          Publicenter\n        ")
                    ],
                    1
                  ),
                  _c(
                    "q-item",
                    {
                      attrs: { clickable: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.logout()
                        }
                      }
                    },
                    [
                      _c("q-icon", {
                        staticClass: "icone-menu-suspenso fas fa-sign-out-alt"
                      }),
                      _vm._v("\n          Sair\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }